import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CATS = ["All", "Residential", "Commercial", "Industrial"];

export default function SelectedWork() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    axios.get(`${API}/projects`).then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(
    () => (filter === "All" ? projects : projects.filter((p) => p.category === filter)),
    [filter, projects]
  );

  return (
    <section id="work" data-testid="section-work" className="bg-bone py-24 md:py-40">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 items-end mb-12 reveal">
          <p className="label col-span-12 md:col-span-2">03 — Selected work</p>
          <h2 className="display col-span-12 md:col-span-7 text-[9vw] md:text-6xl lg:text-[5rem] leading-[0.98] tracking-tighter">
            Recent projects <span className="italic font-light">across</span> Australia.
          </h2>
          <div className="col-span-12 md:col-span-3 flex flex-wrap gap-2 md:justify-end">
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`work-filter-${c.toLowerCase()}`}
                onClick={() => setFilter(c)}
                className={`px-4 py-2 text-[12px] uppercase tracking-[0.2em] border transition-colors ${
                  filter === c ? "bg-ink text-bone border-ink" : "border-ink/30 text-ink hover:border-ink"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
          {filtered.map((p, i) => {
            const span = [
              "md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6",
            ][i % 6];
            const aspect = i % 2 === 0 ? "aspect-[5/4]" : "aspect-[4/5]";
            return (
              <Link
                key={p.slug}
                to={`/work/${p.slug}`}
                data-testid={`project-card-${p.slug}`}
                className={`reveal group ${span} cursor-arrow`}
              >
                <div className={`relative overflow-hidden ${aspect} bg-sand`}>
                  <img
                    src={p.thumb}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/15 transition-colors" />
                  <span className="absolute top-5 left-5 label text-bone bg-ink/70 backdrop-blur px-2 py-1">
                    {p.category} · {p.location}
                  </span>
                  <span className="absolute bottom-5 right-5 w-12 h-12 bg-bone text-ink rounded-full flex items-center justify-center text-xl opacity-0 group-hover:opacity-100 transition-opacity">
                    →
                  </span>
                </div>
                <div className="mt-5 flex items-baseline justify-between">
                  <h3 className="display text-2xl md:text-3xl">{p.title}</h3>
                  <p className="label">{p.year}</p>
                </div>
                <p className="mt-2 text-sm text-muted2 max-w-md">{p.summary}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
